import { render, staticRenderFns } from "./AlternativeTitlesEditPanelDialog.vue?vue&type=template&id=6f8e2cc1"
import script from "./AlternativeTitlesEditPanelDialog.vue?vue&type=script&lang=js"
export * from "./AlternativeTitlesEditPanelDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports